import { Box } from '@mui/material';
import { MicDisabledIcon } from '../Icons/MicDisabledIcon';

export function FailedMicCheckState() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      aria-label="Microphone Access Denied"
    >
      <Box
        sx={{
          width: 70,
          height: 70,
          borderRadius: '50%',
          backgroundColor: '#9CA3AF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <MicDisabledIcon
          pathFill="#FFFFFF"
          sx={{
            fontSize: '32px',
            width: '32px',
            height: '26px',
          }}
        />
      </Box>
    </Box>
  );
}
